import { Link } from 'react-router-dom';
import projects from './projects-data';

function ProjectsGrid({ size }) {
    return (
        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-3">
            {
                projects.slice(0, size).map(project => {
                    return (
                        <div className="project-container" key={project.id}>
                            <Link to={`/project`} state={{ projectId: project.id }}>
                                <div className="project-card block rounded-2.5xl border border-khi-100 bg-white p-[1.1875rem] transition-shadow hover:shadow-lg dark:border-khi-700 dark:bg-khi-700">
                                    <img src={`img/projects/${project.id}/main.${project.hasOwnProperty('imagesMimeType') ? project.imagesMimeType : 'jpg'}`} alt="project" className="project-img-main w-full rounded-[0.625rem]" />
                                    <div className="relative mt-4">
                                        <span className="font-display text-base text-khi-700 hover:text-accent dark:text-white">{project.name}</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default ProjectsGrid